// src/components/ProjectsSection.jsx
import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const projects = [
  {
    id: "luxe-heights",
    title: "Luxe Heights",
    description: "A premium residential complex redefining luxury living.",
    image: "/luxeheights.jpg",
  },
  {
    id: "the-haven",
    title: "The Haven",
    description: "Modern architecture meets timeless elegance.",
    image: "/thehavern.jpg",
  },
  {
    id: "ezrah-avenue",
    title: "Ezrah",
    description: "Exclusive smart homes designed for comfort and style.",
    image: "/ezrahavenue.jpg",
  },
];

export default function ProjectsSection() {
  const [offsetY, setOffsetY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setOffsetY(window.scrollY * 0.15);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section className="relative bg-gray-50 py-24 overflow-hidden">
      {/* Background parallax */}
      <motion.div
        className="absolute inset-0"
        style={{ transform: `translateY(${offsetY}px)` }}
      >
        <div
          className="absolute inset-0 bg-cover bg-center opacity-10 pointer-events-none"
          style={{ backgroundImage: "url('/projects-bg.jpg')" }}
        />
      </motion.div>

      {/* Top diagonal divider */}
      <div className="absolute top-0 left-0 w-full overflow-hidden leading-[0]">
        <svg
          className="relative block w-[calc(100%+1.3px)] h-20"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
          viewBox="0 0 1200 120"
        >
          <path
            d="M1200 0L0 0 892.25 114.72 1200 0z"
            className="fill-white"
          ></path>
        </svg>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-6">
        {/* Title */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
            Our Projects
          </h2>
          <p className="mt-4 text-gray-600 max-w-2xl mx-auto">
            Explore some of our signature developments showcasing luxury,
            innovation, and timeless design.
          </p>
        </div>

        {/* Projects Grid with Flip Animation */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8 perspective">
          {projects.map((project) => (
            <motion.div
              key={project.id}
              className="relative w-full h-72 cursor-pointer"
              whileHover={{ rotateY: 180 }}
              transition={{ duration: 0.8 }}
              style={{ transformStyle: "preserve-3d" }}
            >
              {/* Front Side */}
              <div className="absolute inset-0 rounded-2xl overflow-hidden shadow-lg backface-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-black/40 flex items-end p-6">
                  <h3 className="text-lg font-semibold text-white">
                    {project.title}
                  </h3>
                </div>
              </div>

              {/* Back Side */}
              <div
                className="absolute inset-0 rounded-2xl bg-white shadow-lg p-6 backface-hidden"
                style={{ transform: "rotateY(180deg)" }}
              >
                <h3 className="text-lg font-semibold text-gray-900">
                  {project.title}
                </h3>
                <p className="mt-3 text-gray-600">{project.description}</p>
                <Link to={`/${project.id}`}>
                  <button className="mt-6 inline-block bg-blue-600 text-white px-4 py-2 rounded-lg shadow hover:bg-blue-700 transition">
                    View Details
                  </button>
                </Link>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Bottom diagonal divider */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-[0] rotate-180">
        <svg
          className="relative block w-[calc(100%+1.3px)] h-20"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
          viewBox="0 0 1200 120"
        >
          <path
            d="M1200 0L0 0 892.25 114.72 1200 0z"
            className="fill-white"
          ></path>
        </svg>
      </div>
    </section>
  );
}
